import { InjectionToken } from '@angular/core';
import { XnLazyModules } from '../types/xn-lazymodule.type';

/**
 * Provide a Injection Token to global settings.
 */
export const XN_LAZYMODULE_REGISTER_TOKEN = new InjectionToken<XnLazyModules>('xn-lazymodule-register');
